import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { ProductResultPrice } from 'components/Layout/Header/HeaderBottom/Search/Autocomplete/Result/ProductResult/ProductResultPrice';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import useTranslation from 'next-translate/useTranslation';
import React, { useCallback } from 'react';
import { AutocompleteProductType } from 'types/product';
import { onClickProductDetailGtmEventHandler, onClickSuggestResultGtmEventHandler } from 'utils/Gtm/EventHandlers';

type ProductResultInfoProps = {
    product: AutocompleteProductType;
    autocompleteSearchQueryValue: string;
    index: number;
};

const ProductResultInfo: FC<ProductResultInfoProps> = ({ product, autocompleteSearchQueryValue, index }) => {
    const { t } = useTranslation();
    const { url, type } = useDomainConfig();
    const onProductClickHandler = useCallback(
        (product: AutocompleteProductType, index: number) => () => {
            onClickProductDetailGtmEventHandler(product, 'suggest', index, url);
            onClickSuggestResultGtmEventHandler(autocompleteSearchQueryValue, 'product', product.fullName);
        },
        [autocompleteSearchQueryValue, url],
    );

    return (
        <div className="vl:px-1">
            <div className="mb-3 text-[15px] font-medium leading-snug tracking-wide group-hover:underline vl:mt-1.5 vl:text-small">
                {product.fullName}
            </div>
            {type !== 'web' && <ProductResultPrice product={product} />}
            <ExtendedNextLink
                className="absolute inset-0"
                href={product.slug}
                type="product"
                onClick={onProductClickHandler(product, index)}
            >
                <span className="sr-only">{t('Go to product detail')}</span>
            </ExtendedNextLink>
        </div>
    );
};

export default ProductResultInfo;
